import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Offers from "../views/Offers.vue";
import Methods from "../views/Methods.vue";
import Contact from "../views/Contact.vue";
import Czaszkowa from "../views/Czaszkowa.vue";
import Wzroku from "../views/Wzroku.vue";
import Orto from "../views/Orto.vue";
import McKenziego from "../views/McKenzy.vue";
import PNF from "../views/PNF.vue";
import AnatomyTrains from "../views/AnatomyTrains.vue";
import OMTKaltenborn from "../views/OMTKaltenborn.vue";
import Taping from "../views/Taping.vue";
import NarzadowWewn from "../views/NarzadowWewn.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    component: About,
  },
  {
    path: "/offers",
    name: "Offers",
    component: Offers,
  },
  {
    path: "/metods",
    name: "Methods",
    component: Methods,
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
  },
  {
    path: "/czaszkowo-krzyzowa",
    name: "Czaszkowa",
    component: Czaszkowa,
  },

  {
    path: "/Narzadu-wzroku",
    name: "Wzroku",
    component: Wzroku,
  },
  {
    path: "/Ortopedyczna",
    name: "Orto",
    component: Orto,
  },
  {
    path: "/Metoda-McKenziego",
    name: "McKenziego",
    component: McKenziego,
  },
  {
    path: "/PNF",
    name: "PNF",
    component: PNF,
  },
  {
    path: "/Anatomy-Trains",
    name: "AnatomyTrains",
    component: AnatomyTrains,
  },
  {
    path: "/Kaltenborn",
    name: "Kaltenborn",
    component: OMTKaltenborn,
  },
  {
    path: "/Kinesiology-Taping",
    name: "Taping",
    component: Taping,
  },
  {
    path: "/Narzadow-wewnetrznych",
    name: "Narzadow-wewn",
    component: NarzadowWewn,
  },
];

const router = new VueRouter({
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
  // mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
